






































































































































































































import Vue from 'vue';

import _ from 'lodash';

import {
  Component,
  Prop,
} from 'vue-property-decorator';

import {
  RateTableModel,
  RateTableLocalModel,
  WorkTypeCell,
  defaultTableListLocal, defaultTableList, defaultWorkType,
} from '@/components/RatesPage/types';

interface ChangableObject {
  inChange: boolean;
  value: any;
}

@Component({
  components: {
  },
})
export default class RatesTable extends Vue {
  @Prop({
    type: Object,
    default: false,
  }) readonly workType!: WorkTypeCell

  @Prop()
  readonly suppliers!: any;

  @Prop()
  readonly selectedSuppliers!: any;

  @Prop()
  readonly availableSuppliers!: any;

  @Prop()
  readonly sheetKey: string | undefined;

  comment = this.workType?.comment || ''

  realSelectedSuppliers = _.cloneDeep(this.selectedSuppliers);

  qualityChanges: Record<string, ChangableObject> = {};

  performanceChanges: Record<string, ChangableObject> = {};

  updateComment() {
    this.$emit('updateComment', {
      sheetKey: this.sheetKey,
      comment: this.comment,
    });
  }

  get rateTable(): Array<RateTableLocalModel> {
    if (!this.workType?.cells) {
      return [];
    }
    return this.constructRateTable(this.workType.cells);
  }

  deleteTariff() {
    this.$emit('deleteTariff', this.sheetKey);
  }

  constructRateTable(rateTable: Array<RateTableModel>): Array<RateTableLocalModel> {
    const localRateTable: Array<RateTableLocalModel> = [];
    for (let i = 0; i < rateTable.length; i += 1) {
      const {
        rate,
        quality,
        performance,
      } = rateTable[i];
      if ((!quality.from && quality.from !== 0) || (!performance.from && performance.from !== 0)) {
        continue;
      }
      localRateTable.push({
        price: rate.toString(),
        quality: quality.from.toString(),
        performance: performance.from.toString(),
      });
    }
    return localRateTable;
  }

  selectSupplier() {
    this.$emit('refreshSuppliers', {
      suppliers: this.realSelectedSuppliers,
      key: this.sheetKey,
    });
  }

  get availSupTets() {
    const availSup = this.suppliers.filter((sup: any) => this.realSelectedSuppliers.includes(sup.id) || this.availableSuppliers.includes(sup.id));
    return availSup;
  }

  deconstructRateTable(localRateTable: Array<RateTableLocalModel>): Array<RateTableModel> {
    const rateTable: Array<RateTableModel> = [];
    const performanceList: Array<string> = this.getPerformanceList(localRateTable);
    const qualityList: Array<string> = this.getQualityList(localRateTable);

    for (let i = 0; i < performanceList.length; i += 1) {
      const previousPerformance = i === 0 ? null : performanceList[i - 1];
      const performance = performanceList[i];

      for (let j = 0; j < qualityList.length; j += 1) {
        const previousQuality = j === 0 ? null : qualityList[j - 1];
        const quality = qualityList[j];
        const { price } = localRateTable.find((v: RateTableLocalModel) => v.performance === performance && v.quality === quality) || { price: '0' };

        rateTable.push({
          rate: parseFloat(price),
          quality: {
            from: parseFloat(quality),
            to: previousQuality ? parseFloat(previousQuality) : null,
          },
          performance: {
            from: parseFloat(performance),
            to: previousPerformance ? parseFloat(previousPerformance) : null,
          },
        });

        if (parseFloat(quality)) {
          if (j === (qualityList.length - 1)) {
            rateTable.push({
              rate: parseFloat(price),
              quality: {
                from: 0,
                to: parseFloat(quality),
              },
              performance: {
                from: parseFloat(performance),
                to: previousPerformance ? parseFloat(previousPerformance) : null,
              },
            });
          }
        }

        if (parseFloat(performance)) {
          if (i === (performanceList.length - 1)) {
            rateTable.push({
              rate: parseFloat(price),
              quality: {
                from: parseFloat(quality),
                to: previousQuality ? parseFloat(previousQuality) : null,
              },
              performance: {
                from: 0,
                to: parseFloat(performance),
              },
            });
          }
        }

        if (parseFloat(quality) && parseFloat(performance)) {
          if (j === (qualityList.length - 1) && i === (performanceList.length - 1)) {
            rateTable.push({
              rate: parseFloat(price),
              quality: {
                from: 0,
                to: parseFloat(quality),
              },
              performance: {
                from: 0,
                to: parseFloat(performance),
              },
            });
          }
        }
      }
    }
    return rateTable;
  }

  restoreDefault() {
    this.rateTableChanged(defaultTableListLocal);
  }

  changeCell(quality: string, performance: string, value: string | number) {
    const newRateTable = this.rateTable.map((v: RateTableLocalModel) => {
      if (parseFloat(v.quality) === parseFloat(quality) && parseFloat(v.performance) === parseFloat(performance)) {
        return {
          ...v,
          price: value.toString(),
        };
      }
      return v;
    });
    this.rateTableChanged(newRateTable);
  }

  startQualityChange(quality: string) {
    Vue.set(this.qualityChanges, quality, {
      inChange: true,
      value: quality,
    });
  }

  changeQuality(quality: string) {
    const rateTable: Array<RateTableLocalModel> = this.rateTable;
    const newQuality = this.qualityChanges[quality].value;
    const newRateTable = rateTable.map((v: RateTableLocalModel) => {
      if (parseFloat(v.quality) === parseFloat(quality)) {
        return {
          ...v,
          quality: newQuality,
        };
      }
      return v;
    });
    this.rateTableChanged(newRateTable);
    this.qualityChanges[quality].inChange = false;
  }

  cancelChangeQuality(quality: string) {
    this.qualityChanges[quality].inChange = false;
  }

  startPerformanceChange(performance: string) {
    Vue.set(this.performanceChanges, performance, {
      inChange: true,
      value: performance,
    });
  }

  changePerformance(performance: string) {
    const rateTable: Array<RateTableLocalModel> = this.rateTable;
    const newPerformance = this.performanceChanges[performance].value;
    const newRateTable = rateTable.map((v: RateTableLocalModel) => {
      if (parseFloat(v.performance) === parseFloat(performance)) {
        return {
          ...v,
          performance: newPerformance,
        };
      }
      return v;
    });
    this.rateTableChanged(newRateTable);
    this.performanceChanges[performance].inChange = false;
  }

  cancelChangePerformance(performance: string) {
    this.performanceChanges[performance].inChange = false;
  }

  get builtHeaders() {
    const rateTable = this.rateTable;
    const filteredTable = rateTable
      .filter((v: RateTableLocalModel, i: number) => rateTable.findIndex((vi: RateTableLocalModel) => vi.quality === v.quality) === i)
      .sort((p: any, n: any) => (parseFloat(p.quality) > parseFloat(n.quality) ? -1 : 1));
    const headers: Array<Record<any, any>> = [];
    for (let i = 0; i < filteredTable.length; i += 1) {
      const previous = i === 0 ? null : filteredTable[i - 1];
      const current = filteredTable[i];
      // const next = (i - 1) === filteredTable.length ? null : filteredTable[i + 1];
      let headerText = current.quality.toString();
      if (previous) {
        headerText = `${previous.quality} - ${current.quality}`;
      }
      headers.push({
        text: headerText,
        value: current.quality.toString(),
      });
    }
    return headers;
  }

  get builtItems() {
    const rateTable = this.rateTable;
    const rows = rateTable
      .map((v: any, index: number) => {
        const findIndex = rateTable.findIndex((vi: any) => vi.performance === v.performance);
        if (findIndex === index) {
          const value = _.cloneDeep(v);
          value[value.quality.toString()] = value.price;
          delete value.price;
          const filtered = rateTable.filter((vi: any, indexi: number) => vi.performance === v.performance && index !== indexi);
          for (let i = 0; i < filtered.length; i += 1) {
            const nextValue = filtered[i];
            value[nextValue.quality.toString()] = nextValue.price;
          }
          return value;
        }
        return null;
      })
      .filter((v: any) => !!v)
      .sort((p: any, n: any) => (parseFloat(p.performance) > parseFloat(n.performance) ? -1 : 1));
    const finalRows = [];
    for (let i = 0; i < rows.length; i += 1) {
      const previous = i === 0 ? null : rows[i - 1];
      const current = rows[i];
      // const next = (i - 1) === rows.length ? null : rows[i + 1];
      let rowName = current.performance.toString();
      if (previous) {
        rowName = `${previous.performance} - ${current.performance}`;
      }
      finalRows.push({
        ...current,
        rowName,
      });
    }
    return finalRows;
  }

  rateTableChanged(rateTable: Array<RateTableLocalModel>) {
    this.$emit('changeRateTable', {
      cells: this.deconstructRateTable(rateTable),
      suppliers: this.realSelectedSuppliers,
      key: this.workType.key,
    });
  }

  removePerformance(performance: string) {
    const rateTable: Array<RateTableLocalModel> = this.rateTable;
    const newRateTable = rateTable.filter((v: RateTableLocalModel) => parseFloat(v.performance) !== parseFloat(performance));
    this.rateTableChanged(newRateTable);
  }

  removeQuality(quality: string) {
    const rateTable: Array<RateTableLocalModel> = this.rateTable;
    const newRateTable = rateTable.filter((v: RateTableLocalModel) => parseFloat(v.quality) !== parseFloat(quality));
    this.rateTableChanged(newRateTable);
  }

  getPerformanceList(rateTable: Array<RateTableLocalModel>): Array<string> {
    return rateTable
      .filter((v: RateTableLocalModel, i: number) => rateTable.findIndex((vi: RateTableLocalModel) => vi.performance === v.performance) === i)
      .sort((p: any, n: any) => (parseFloat(p.performance) > parseFloat(n.performance) ? -1 : 1))
      .map((v: any) => v.performance);
  }

  getQualityList(rateTable: Array<RateTableLocalModel>): Array<string> {
    return rateTable
      .filter((v: RateTableLocalModel, i: number) => rateTable.findIndex((vi: RateTableLocalModel) => vi.quality === v.quality) === i)
      .sort((p: any, n: any) => (parseFloat(p.quality) > parseFloat(n.quality) ? -1 : 1))
      .map((v: any) => v.quality);
  }

  addQuality(fromQuality: string) {
    const rateTable: Array<RateTableLocalModel> = this.rateTable;
    const performanceList: Array<string> = this.getPerformanceList(rateTable);
    const qualityList: Array<string> = this.getQualityList(rateTable);
    const fromQualityFloat = parseFloat(fromQuality);
    const lesserQuality: string = qualityList.find((v: string) => parseFloat(v) < fromQualityFloat) || fromQuality;
    const qualityDiff = fromQualityFloat - parseFloat(lesserQuality);
    let newQuality: number = qualityDiff === 0 ? fromQualityFloat - 0.5 : fromQualityFloat - (qualityDiff / 2);
    newQuality = Math.round(newQuality * 100) / 100;
    const newRateCells: Array<RateTableLocalModel> = performanceList.map((v: string) => ({
      performance: v,
      quality: newQuality.toString(),
      price: '0',
    }));
    this.rateTableChanged([...rateTable, ...newRateCells]);
  }

  addPerformance(fromPerformance: string) {
    const rateTable: Array<RateTableLocalModel> = this.rateTable;
    const performanceList: Array<string> = this.getPerformanceList(rateTable);
    const qualityList: Array<string> = this.getQualityList(rateTable);
    const fromPerformanceFloat = parseFloat(fromPerformance);
    const lesserPerformance: string = performanceList.find((v: string) => parseFloat(v) < fromPerformanceFloat) || fromPerformance;
    const performanceDiff = fromPerformanceFloat - parseFloat(lesserPerformance);
    let newPerformance: number = performanceDiff === 0 ? fromPerformanceFloat - 0.5 : fromPerformanceFloat - (performanceDiff / 2);
    newPerformance = Math.round(newPerformance * 100) / 100;
    const newRateCells: Array<RateTableLocalModel> = qualityList.map((v: string) => ({
      performance: newPerformance.toString(),
      quality: v,
      price: '0',
    }));
    this.rateTableChanged([...rateTable, ...newRateCells]);
  }
}

